import "./PhotoTypeSelect.css";

interface Item {
  label: string;
  value: string;
}

interface PhotoTypeSelectProps {
  items: Item[];
  value: string;
  setType: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const PhotoTypeSelect = ({
  items,
  value,
  setType,
}: PhotoTypeSelectProps) => {
  return (
    <select className="photo-type-select" value={value} onChange={setType}>
      {items.map((item) => (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};
